import { render, staticRenderFns } from "./PathActivitiesSection.vue?vue&type=template&id=a045b30a&"
import script from "./PathActivitiesSection.vue?vue&type=script&lang=js&"
export * from "./PathActivitiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports